module.exports = __webpack_public_path__ + "img/hair_lightBrown.1a0223be.png";